import React from 'react'

const Tableau = (
  <div className='md:w-4/5 mx-auto py-10 text-lg'>
    <h1 className='text-2xl font-bold'>Tableau</h1>
    <div>
      <br />
      <p className='md:px-5 text-gray-500'>
        Tableau is referred to as a data visualization software that comes with powerful graphics
        to create interactive visualizations. It is majorly used by industries working in the field of
        business intelligence and analytics.
      </p>
      <br />
      <p className='md:px-5 text-gray-500'>
        The most significant feature of Tableau is its ability to interact with different
        spreadsheets, databases, online analytical processing (OLAP) cubes, etc. Apart from
        these features, Tableau can also visualize geographical data by plotting longitudes and
        latitudes on maps.
      </p>
      <br />
      <p className='md:px-5'>
        The following are the main features of Tableau:
      </p>
      <br />
      <div className='md:px-5'>
        <ul className='md:px-10 list-disc pl-5 text-gray-500'>
          <li>
            Allows to connect with and extract data from multiple data sources and has the
            ability to visualize large datasets to find patterns and correlations.
          </li>
          <br />
          <li>
            The desktop feature helps create customized reports and dashboards to get
            real-time insights and updates.
          </li>
          <br />
          <li>
            The cross-database join functionality allows to make calculated fields and join
            tables for solving complex data problems.
          </li>
        </ul>
      </div>
    </div>
  </div>
)

export default Tableau